import { GiRing } from 'react-icons/gi';

export const RingIcon = ({ size = 20, ...attrs }) => {
  return <GiRing />;
};

export const DaughterIcon = ({ size = 20, ...attrs }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      {...attrs}
      viewBox="0 0 20 20"
    >
      <path
        fill="#B3E59F"
        d="M16.201 19.26v-2.563a4.783 4.783 0 00-4.782-4.782H8.58a4.783 4.783 0 00-4.783 4.782v2.564l6.202.351 6.201-.351z"
      ></path>
      <path
        fill="#CF8151"
        d="M3.84 11.833c1.307.32 2.642-1.163 2.059-2.571l-.98-.392s-1.249.62-1.08 2.963z"
      ></path>
      <path
        fill="#95D6A4"
        d="M4.004 20H5.94l.308-.352.308.352h6.887l.308-.352.308.352h1.937a.205.205 0 00.205-.205v-.534H3.8v.534c0 .113.092.205.205.205z"
      ></path>
      <path
        fill="#E2AE84"
        d="M11.592 11.915s.073 1.9-1.592 1.9c-1.666 0-1.593-1.9-1.593-1.9h3.185z"
      ></path>
      <path
        fill="#BD6E45"
        d="M6.248 9.401l-.349-.14c-.105 1.555-1.477 2.317-2.059 2.572.014.185.036.381.068.589.021.133.162.21.286.157.64-.277 2.316-1.2 2.054-3.178z"
      ></path>
      <path
        fill="#CF8151"
        d="M15.13 7.471C16.316 1.641 12.88 0 10.002 0 7.125 0 3.69 1.642 4.875 7.471H15.13z"
      ></path>
      <path
        fill="#E2AE84"
        d="M5.983 9.035l.144-.354.492-.744-.503-1.09a1.295 1.295 0 00-1.374.918c0 .77.654 1.27 1.24 1.27z"
      ></path>
      <path
        fill="#D7A379"
        d="M5.985 8.69c-.587 0-1.082-.39-1.24-.925a1.294 1.294 0 001.504 1.637l.256-.438-.376-.283a1.307 1.307 0 01-.144.008z"
      ></path>
      <path
        fill="#CF8151"
        d="M16.16 11.833c-1.307.32-2.642-1.163-2.058-2.571l.979-.392s1.25.62 1.08 2.963z"
      ></path>
      <path
        fill="#BD6E45"
        d="M13.75 9.401l.35-.14c.105 1.555 1.477 2.317 2.059 2.572a7.124 7.124 0 01-.068.589.206.206 0 01-.286.157c-.64-.277-2.316-1.2-2.054-3.178z"
      ></path>
      <path
        fill="#E2AE84"
        d="M14.015 9.035l-.144-.354-.492-.744.503-1.09a1.295 1.295 0 011.374.918c0 .77-.654 1.27-1.24 1.27z"
      ></path>
      <path
        fill="#D7A379"
        d="M14.016 8.69c.586 0 1.081-.39 1.24-.925a1.296 1.296 0 01-1.504 1.637l-.256-.438.376-.283c.047.005.095.008.144.008z"
      ></path>
      <path
        fill="#F0C69E"
        d="M10.174 3.603c1.383 2.2 3.708 3.245 3.708 3.245V8.015c0 2.144-1.738 3.918-3.882 3.918s-3.882-1.774-3.882-3.918V6.848s2.325-1.045 3.708-3.245a.205.205 0 01.348 0z"
      ></path>
      <path
        fill="#E6BA94"
        d="M10 11.545a3.882 3.882 0 01-3.882-3.882v.74a3.882 3.882 0 007.764 0v-.74A3.882 3.882 0 0110 11.545z"
      ></path>
      <path
        fill="#78C2A4"
        d="M6.556 17.288v1.986l-.28.351-.336-.351v-1.986a.308.308 0 11.616 0zM14.06 17.288v1.986l-.309.351-.308-.351v-1.986a.308.308 0 11.616 0z"
      ></path>
      <path
        fill="#66B394"
        d="M5.94 19.26h.616V20H5.94v-.74zM13.444 19.26h.616V20h-.616v-.74z"
      ></path>
      <path
        fill="#5E6B75"
        d="M8.116 6.895a.309.309 0 00-.308.309v.872a.309.309 0 00.617 0v-.872a.309.309 0 00-.309-.309zM11.886 8.384c.17 0 .308-.138.308-.308v-.872a.309.309 0 10-.617 0v.872c0 .17.138.308.309.308z"
      ></path>
      <path
        fill="#DC4955"
        d="M11.135 9.752a.308.308 0 00-.57-.234c-.002.002-.12.26-.564.26-.445 0-.563-.258-.564-.26a.308.308 0 00-.57.234c.098.239.447.642 1.134.642.686 0 1.036-.403 1.134-.642z"
      ></path>
    </svg>
  );
};

export const SonIcon = ({ size = 20, ...attrs }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      {...attrs}
      viewBox="0 0 20 20"
    >
      <path
        fill="#9EC8FC"
        d="M16.202 19.261v-2.563a4.783 4.783 0 00-4.782-4.783H8.582a4.783 4.783 0 00-4.783 4.783v2.563l6.201.352 6.202-.352z"
      ></path>
      <path
        fill="#E2AE84"
        d="M11.594 11.915s.073 1.9-1.593 1.9c-1.665 0-1.592-1.9-1.592-1.9h3.185z"
      ></path>
      <path
        fill="#26457D"
        d="M15.127 7.471a15.06 15.06 0 00-.008-2.014H4.881a15.06 15.06 0 00-.008 2.014h10.254z"
      ></path>
      <path
        fill="#E2AE84"
        d="M4.746 7.765c0 .49.325 1.32.912 1.32l.473-.404.59-.452-.6-1.382a1.295 1.295 0 00-1.374.918z"
      ></path>
      <path
        fill="#D7A379"
        d="M5.986 8.689c-.587 0-1.082-.39-1.24-.925A1.294 1.294 0 006.25 9.401l.279-.37-.4-.35a1.297 1.297 0 01-.143.008z"
      ></path>
      <path
        fill="#E2AE84"
        d="M15.257 7.765c0 .491-.325 1.32-.912 1.32l-.473-.403-.59-.452.6-1.383a1.295 1.295 0 011.374.918z"
      ></path>
      <path
        fill="#D7A379"
        d="M14.016 8.689c.586 0 1.081-.39 1.24-.925a1.296 1.296 0 01-1.504 1.637l-.28-.37.4-.35c.047.005.095.008.144.008z"
      ></path>
      <path
        fill="#F0C69E"
        d="M12.607 5.456l-2.605-.352-2.605.352c-.74 1.217-1.277 1.39-1.277 1.39v1.288c0 2.143 1.738 3.798 3.882 3.798 2.143 0 3.881-1.655 3.881-3.798V6.846s-.537-.172-1.276-1.39z"
      ></path>
      <path
        fill="#E6BA94"
        d="M10.002 11.545A3.882 3.882 0 016.12 7.664v.739a3.882 3.882 0 007.763 0v-.74a3.882 3.882 0 01-3.881 3.882z"
      ></path>
      <path
        fill="#80B6FC"
        d="M4.004 20h1.937l.308-.352.308.352h6.887l.308-.352.308.352h1.937a.205.205 0 00.205-.205v-.534H3.8v.534c0 .113.092.205.205.205z"
      ></path>
      <path
        fill="#6EAAF3"
        d="M6.556 17.288v1.973l-.308.351-.308-.351v-1.973a.308.308 0 11.616 0zM14.06 17.288v1.973l-.309.351-.308-.351v-1.973a.308.308 0 11.616 0z"
      ></path>
      <path
        fill="#5D9EE6"
        d="M5.94 19.26h.616V20H5.94v-.74zM13.443 19.26h.616V20h-.616v-.74z"
      ></path>
      <path
        fill="#DC4955"
        d="M15.302 4.717C14.836 1.085 12.362 0 10 0c-2.36 0-4.835 1.085-5.3 4.717l5.3.352 5.3-.352z"
      ></path>
      <path
        fill="#D82F3C"
        d="M4.7 4.718c-.021.168-.038.34-.051.52a.205.205 0 00.205.219h3.497L10 5.105l1.65.352h3.498c.118 0 .213-.101.205-.22a9.331 9.331 0 00-.052-.52H4.7z"
      ></path>
      <path
        fill="#26457D"
        d="M11.65 4.32L10 4.673l-1.65-.351v-.104a1.65 1.65 0 113.3 0v.104z"
      ></path>
      <path
        fill="#F6E080"
        d="M11.651 4.717l-1.65.352-1.65-.352v-.396h3.3v.396z"
      ></path>
      <path fill="#ECCD61" d="M8.35 4.718h3.301v.739h-3.3v-.74z"></path>
      <path
        fill="#5E6B75"
        d="M8.114 6.896a.309.309 0 00-.308.308v.872a.309.309 0 00.617 0v-.872a.309.309 0 00-.309-.308zM11.883 8.385c.171 0 .31-.139.31-.309v-.872a.309.309 0 10-.618 0v.872c0 .17.138.309.309.309z"
      ></path>
      <path
        fill="#DC4955"
        d="M11.134 9.754a.308.308 0 00-.57-.235c0 .003-.12.26-.563.26-.444 0-.563-.257-.564-.26a.308.308 0 00-.57.235c.099.238.448.641 1.134.641.686 0 1.035-.403 1.133-.641z"
      ></path>
    </svg>
  );
};

export const ParentsIcon = ({ size = 20, ...attrs }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      {...attrs}
      viewBox="0 0 20 20"
    >
      <g clipPath="url(#clip0)">
        <path
          fill="#F1B986"
          d="M11.095 16.34s-.948.282-1.273-.043c-.326-.325 0-1.16 0-1.16l1.61-.659-.337 1.862z"
        ></path>
        <path
          fill="#F1D0A5"
          d="M18.267 16.297c-.164.165-.49.174-.77.142-.272-.03-.503-.099-.503-.099l-.415-1.736.528.167 1.16.367s.326.834 0 1.16z"
        ></path>
        <path
          fill="#F1B986"
          d="M17.498 16.439c-.273-.03-.504-.1-.504-.1l-.415-1.735.528.167.45.366c0 .317-.248.916-.06 1.302z"
        ></path>
        <path
          fill="#8078BC"
          d="M16.976 15.138s-1.938 1.596-2.932.601c-.994.995-2.933-.601-2.933-.601h-1.29c0-3.608 1.465-4.8 1.719-4.98h5.008c.254.18 1.719 1.372 1.719 4.98h-1.29z"
        ></path>
        <path
          fill="#5E54AC"
          d="M11.162 14.479c.087-.806.325-1.284.325-1.284l.148 1.93M13.743 9.928h.603v4.927h-.603V9.928zM17.556 15.138h-.58c0-.88-.319-1.734-.319-1.734s.802.283.9 1.734zM12.224 10.158c-.596.805-1.682 2.602-1.654 4.98h-.75c0-3.608 1.466-4.8 1.72-4.98h.684z"
        ></path>
        <path
          fill="#665E66"
          d="M16.535 19.058l-.118.236-1.882-.236s.502-2.325-.492-3.32c-.994.995-.492 3.32-.492 3.32l-1.075.176-.926-.176c-.64-1.64-.44-3.92-.44-3.92 0-.226.022-.451.053-.66h5.76c.032.209.053.434.053.66 0 0 .2 2.28-.44 3.92z"
        ></path>
        <path
          fill="#454045"
          d="M12.143 19.058l-.524.15-.069-.15c-.64-1.64-.44-3.92-.44-3.92 0-.226.022-.451.053-.66h.949c-.201.754-.45 2.317.03 4.58zM15.057 19.058h-.522s.502-2.325-.492-3.32c1.014 0 1.536 1.747 1.014 3.32z"
        ></path>
        <path
          fill="#AA593D"
          d="M10.95 20h2.601v-.941h-1.658a.942.942 0 00-.942.941z"
        ></path>
        <path
          fill="#934D36"
          d="M12.493 19.059a.942.942 0 00-.942.941h-.6c0-.52.421-.941.941-.941h.601z"
        ></path>
        <path
          fill="#AA593D"
          d="M17.134 20h-2.6v-.941h1.659c.52 0 .941.421.941.941z"
        ></path>
        <path
          fill="#F1B986"
          d="M18.506 7.106h.007a.972.972 0 000-1.943H9.576a.972.972 0 000 1.943h.005"
        ></path>
        <path
          fill="#F1D0A5"
          d="M14.045 0c2.284 0 3.983 1.069 4.231 2.64.22 1.753.284 3.507.194 5.261a2.482 2.482 0 01-2.364 2.354 43.753 43.753 0 01-4.122 0A2.482 2.482 0 019.619 7.9a30.002 30.002 0 01.194-5.262C10.06 1.07 11.76 0 14.045 0z"
        ></path>
        <path
          fill="#F1B986"
          d="M12.824 10.287c-.28-.008-.56-.019-.84-.032A2.482 2.482 0 019.618 7.9a30.003 30.003 0 01.193-5.262c.23-1.456 1.708-2.48 3.744-2.622-1.086.23-1.86 1.225-1.988 2.606a51.84 51.84 0 00-.113 5.296c.038 1.277.629 2.295 1.369 2.368z"
        ></path>
        <path
          fill="#EADFDA"
          d="M18.47 7.901a2.483 2.483 0 01-2.365 2.354 44.028 44.028 0 01-3.28.031h-.005a45.037 45.037 0 01-.837-.031A2.483 2.483 0 019.62 7.9a29.931 29.931 0 01-.038-1.782c.691 0 1.126.893 1.86 1.159.128.046.264.073.413.073 1.004 0 1.073-.802 2.19-.802 1.118 0 1.188.802 2.19.802 1.003 0 1.462-1.232 2.274-1.232A29.86 29.86 0 0118.47 7.9z"
        ></path>
        <path
          fill="#C6BEB9"
          d="M12.822 10.286h-.002a45.004 45.004 0 01-.837-.031A2.483 2.483 0 019.619 7.9 29.931 29.931 0 019.58 6.12c.692 0 1.127.893 1.86 1.159.004.213.008.427.015.641.038 1.276.627 2.293 1.367 2.367zM10.58 3.757c-.256.246-.579.48-.976.687-.324-.647-.25-2.747.893-3.19.332-.128.604-.02.76.231.295.47.186 1.44-.677 2.272z"
        ></path>
        <path
          fill="#EADFDA"
          d="M10.58 3.757c-.056-.742.112-1.764.678-2.272.294.47.185 1.44-.678 2.272zM18.484 4.444c.323-.646.25-2.747-.893-3.189-1.143-.442-1.561 1.92.893 3.19z"
        ></path>
        <path
          fill="#454045"
          d="M11.974 5.19c-.223 0-.405.27-.405.603 0 .333.182.603.405.603.224 0 .405-.27.405-.603 0-.332-.181-.603-.405-.603zM16.112 5.19c-.223 0-.405.27-.405.603 0 .333.182.603.405.603.224 0 .405-.27.405-.603 0-.332-.181-.603-.405-.603z"
        ></path>
        <path
          fill="#C6BEB9"
          d="M14.043 8.687c-.502 0-.966-.293-1.182-.747a.302.302 0 11.546-.259.707.707 0 00.636.403c.27 0 .52-.158.636-.403a.302.302 0 01.546.26c-.216.453-.68.746-1.182.746z"
        ></path>
        <path
          fill="#F1B986"
          d="M2.648 16.34s-.948.282-1.273-.043c-.325-.325 0-1.16 0-1.16l1.61-.659-.337 1.862z"
        ></path>
        <path
          fill="#F1D0A5"
          d="M9.82 15.137s.326.835 0 1.16c-.325.325-1.273.043-1.273.043l-.415-1.736 1.689.533z"
        ></path>
        <path
          fill="#F1B986"
          d="M9.187 16.452c-.327-.019-.638-.112-.638-.112l-.392-1.635.954.433c0 .379-.229.964.076 1.314z"
        ></path>
        <path
          fill="#8BC852"
          d="M8.53 15.138s.2 2.28-.44 3.92l-.368.686-4.38-.089h-.045l-.192-.597c-.6-1.536-.462-3.633-.442-3.893l.001-.012.001-.015h-1.29c0-3.609 1.465-4.8 1.719-4.98h5.008c.254.18 1.719 1.371 1.719 4.98H8.53z"
        ></path>
        <path
          fill="#6EA533"
          d="M5.599 19.58a.31.31 0 01-.302-.318v-7.675a.31.31 0 01.302-.318.31.31 0 01.301.318v7.675a.31.31 0 01-.301.318zM3.94 19.058l-.597.597h-.046l-.191-.597c-.6-1.535-.462-3.632-.442-3.893v-.011l.002-.016c0-.88.32-1.734.32-1.734s.148 5.092.954 5.654zM9.11 15.138h-.58c0-.88-.32-1.734-.32-1.734s.803.283.9 1.734zM3.78 10.158c-.596.804-1.682 2.601-1.654 4.98h-.749c0-3.609 1.465-4.8 1.719-4.98h.684z"
        ></path>
        <path
          fill="#665E66"
          d="M2.999 20h2.6v-.941H3.94A.942.942 0 003 20z"
        ></path>
        <path
          fill="#454045"
          d="M4.54 19.059A.942.942 0 003.6 20h-.6c0-.52.421-.941.941-.941h.6z"
        ></path>
        <path
          fill="#665E66"
          d="M8.199 20h-2.6v-.941h1.658c.52 0 .942.421.942.941z"
        ></path>
        <path
          fill="#EADFDA"
          d="M5.608 2.784a1.392 1.392 0 100-2.784 1.392 1.392 0 000 2.784z"
        ></path>
        <path
          fill="#C6BEB9"
          d="M6.001 2.728a1.392 1.392 0 110-2.67 1.393 1.393 0 000 2.67z"
        ></path>
        <path
          fill="#EADFDA"
          d="M9.773 5.502L5.598 8.244l-3.122-2.06-1.033-.682S.308 1.058 5.598 1.058h.02c5.29 0 4.155 4.444 4.155 4.444z"
        ></path>
        <path
          fill="#C6BEB9"
          d="M3.665 5.172l-1.19 1.011-1.032-.681S.308 1.058 5.598 1.058c-2.893.711-1.933 4.114-1.933 4.114z"
        ></path>
        <path
          fill="#F1B986"
          d="M1.445 5.501h3.482v1.816H1.425a.908.908 0 010-1.816h.02z"
        ></path>
        <path
          fill="#F1D0A5"
          d="M10.681 6.409a.908.908 0 01-.907.908H5.886V5.5h3.888c.501 0 .908.407.908.908z"
        ></path>
        <path
          fill="#6EA533"
          d="M5.599 11.79c1.13 0 2.047-.665 2.047-1.486 0-.822-.916-1.487-2.047-1.487-1.13 0-2.047.665-2.047 1.486 0 .822.916 1.487 2.047 1.487z"
        ></path>
        <path
          fill="#F1B986"
          d="M5.597 11.186c.798 0 1.444-.395 1.444-.883s-.646-.883-1.444-.883c-.797 0-1.443.395-1.443.883s.646.883 1.443.883z"
        ></path>
        <path
          fill="#F1D0A5"
          d="M9.738 8.055a2.322 2.322 0 01-2.212 2.203c-.94.044-1.881.056-2.822.036H4.7c-.344-.008-.687-.02-1.03-.036a2.323 2.323 0 01-2.213-2.203 28.017 28.017 0 01-.015-2.554s.983-.05 2.223-.329c1.102-.248 2.408-.677 3.409-1.414 0 0 1.044 1.743 2.679 1.743.034.852.03 1.703-.015 2.554z"
        ></path>
        <path
          fill="#F1B986"
          d="M4.7 10.293c-.344-.007-.688-.02-1.032-.035a2.323 2.323 0 01-2.212-2.203 28.017 28.017 0 01-.014-2.554s.982-.05 2.222-.33v.001c-.276 2.375.004 5.078 1.035 5.121z"
        ></path>
        <path
          fill="#EAAC9D"
          d="M5.598 8.546c-.477 0-.917-.278-1.122-.71a.302.302 0 01.546-.258.641.641 0 00.576.364.641.641 0 00.576-.364.302.302 0 11.546.259c-.205.43-.645.709-1.122.709z"
        ></path>
        <path
          fill="#454045"
          d="M3.667 5.728c-.209 0-.38.252-.38.563 0 .311.171.564.38.564.21 0 .38-.253.38-.564 0-.31-.17-.563-.38-.563zM7.531 5.728c-.209 0-.38.252-.38.563 0 .311.171.564.38.564.21 0 .38-.253.38-.564 0-.31-.17-.563-.38-.563z"
        ></path>
        <path
          fill="#EAAC9D"
          d="M8.18 7.84c.34 0 .616-.174.616-.388 0-.215-.275-.389-.615-.389-.34 0-.616.174-.616.389 0 .214.276.388.616.388zM3.015 7.84c.34 0 .615-.174.615-.388 0-.215-.275-.389-.615-.389-.34 0-.616.174-.616.389 0 .214.276.388.616.388z"
        ></path>
        <path
          fill="#6EA533"
          d="M7.874 16.308H6.871a.302.302 0 110-.604h1.003a.302.302 0 110 .604zM4.326 16.308H3.323a.302.302 0 110-.604h1.003a.302.302 0 110 .604z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0H20V20H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const MaleIcon = ({ size = 20, ...attrs }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1"
      viewBox="0 0 48 48"
      width={size}
      height={size}
      {...attrs}
    >
      <path fill="#FF9800" d="M24 37L19 31 19 25 29 25 29 31z"></path>
      <g fill="#FFA726">
        <circle cx="33" cy="19" r="2"></circle>
        <circle cx="15" cy="19" r="2"></circle>
      </g>
      <path
        fill="#FFB74D"
        d="M33 13c0-7.6-18-5-18 0v7c0 5 4 9 9 9s9-4 9-9v-7z"
      ></path>
      <path
        fill="#424242"
        d="M24 4c-6.1 0-10 4.9-10 11v2.3l2 1.7v-5l12-4 4 4v5l2-1.7V15c0-4-1-8-6-9l-1-2h-3z"
      ></path>
      <g fill="#784719">
        <circle cx="28" cy="19" r="1"></circle>
        <circle cx="20" cy="19" r="1"></circle>
      </g>
      <path fill="#fff" d="M24 43L19 31 24 32 29 31z"></path>
      <path
        fill="#D32F2F"
        d="M23 35L22.3 39.5 24 43.5 25.7 39.5 25 35 26 34 24 32 22 34z"
      ></path>
      <path
        fill="#546E7A"
        d="M29 31l-5 12-5-12S8 33 8 44h32c0-11-11-13-11-13z"
      ></path>
    </svg>
  );
};

export const FemaleIcon = ({ size = 20, ...attrs }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1"
      viewBox="0 0 48 48"
      width={size}
      height={size}
      {...attrs}
    >
      <path fill="#BF360C" d="M16 15H32V33H16z"></path>
      <path fill="#78909C" d="M40 44H8c0-11 11-13 11-13h10s11 2 11 13z"></path>
      <path fill="#FF9800" d="M24 37c-2.2 0-5-6-5-6v-6h10v6s-2.8 6-5 6z"></path>
      <path
        fill="#FFB74D"
        d="M33 14c0-7.6-18-5-18 0v7c0 5 4 9 9 9s9-4 9-9v-7z"
      ></path>
      <path
        fill="#FF5722"
        d="M24 4C17.9 4 9 7.4 9 27.3l7 4.7V19l12-7 4 5v15l7-6c0-4-.7-20-11-20l-1-2h-3z"
      ></path>
      <path
        fill="#FFB74D"
        d="M24 38c-4.4 0-5-7-5-7s2.5 4 5 4 5-4 5-4-.6 7-5 7z"
      ></path>
      <circle cx="28" cy="21" r="1" fill="#784719"></circle>
      <circle cx="20" cy="21" r="1" fill="#784719"></circle>
    </svg>
  );
};
